<!--
@Time : 2020/11/28 7:27 下午
@Author : yekong
@File : fuwu.vue
@Software : PhpStorm
-->
<template>
  <div>
    <titles title="监管与服务"></titles>
    <div class="echarts" ref="echarts" :style="{width: '820px', height: '380px'}"></div>
  </div>
</template>

<script>
import titles from "@/components/title";

export default {
  name: "fuwu",
  components: {titles},
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.echarts)
      // 绘制图表
      myChart.setOption({
        grid: {
          top: "8%",
          left: "4%",
          right: "4%",
          bottom: "28%"//也可设置left和right设置距离来控制图表的大小
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: false
            }
          }
        },
        legend: {
          data: ["全国", "大连"],
          top: "0%",
          left: '0',
          textStyle: {
            color: "#ffffff"
          }
        },
        xAxis: {
          data: [
            "用电情况",
            "办理纳税",
            "不动产登记",
            "水汽情况",
            "商标注册",
            "工业产品",
            "财税优惠",
            "贷款通关",
            "企业开办",
          ],
          axisLine: {
            show: false, //隐藏X轴轴线
            lineStyle: {
              color: '#01FCE3'
            },

          },
          axisTick: {
            show: false //隐藏X轴刻度
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 18,
              color: "rgba(255, 255, 255, 1)" //X轴文字颜色
            },
            formatter: function (value) {
              //x轴的文字改为竖版显示
              var str = value.split("");
              return str.join("\n");
            }
          },

        },
        yAxis: [{
          type: "value",
          nameTextStyle: {
            color: "#ebf8ac"
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#FFFFFF'
            }
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#ebf8ac"
            }
          },

        },
          {
            type: "value",
            position: "right",
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false,
              formatter: "{value} %", //右侧Y轴文字显示
              textStyle: {
                color: "#ebf8ac"
              }
            }
          },
          {
            type: "value",
            gridIndex: 0,
            min: 50,
            max: 100,
            splitNumber: 8,
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitArea: {
              show: false,
              areaStyle: {
                color: ["rgba(250,250,250,0.0)", "rgba(250,250,250,0.05)"]
              }
            }
          }
        ],
        series: [{
          name: "全国",
          type: "line",
          yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
          smooth: true, //平滑曲线显示
          showAllSymbol: true, //显示所有图形。
          symbol: "circle", //标记的图形为实心圆
          symbolSize: 10, //标记的大小
          // itemStyle: {
          //   //折线拐点标志的样式
          //   color: "rgba(229, 116, 68, 1)"
          // },
          itemStyle: {
            normal: {
              color: '#fff',
              borderColor: "rgba(229, 116, 68, 1)",
              borderWidth: 1
            }
          },
          lineStyle: {
            color: "rgba(229, 116, 68, 1)"
          },
          // areaStyle: {
          //   color: "rgba(5,140,255, 0.2)"
          // },
          data: [4.2, 3.8, 4.8, 3.5, 2.9, 2.8, 3, 5, 5]
        },
          {
            name: "大连",
            type: "bar",
            barWidth: 31,
            itemStyle: {
              normal: {
                color: 'rgba(48, 182, 218, 1)'
              }
            },
            data: [4.2, 3.8, 4.8, 3.5, 2.9, 2.8, 3, 5, 2]
          }
        ]
      });
    }
  },
  mounted() {
    this.drawLine();
  },
}
</script>

<style lang="scss" scoped>
.echarts {
  background: url("../../assets/imgbg.png") 20px 176px no-repeat;
  background-size: 779px 104px;
}
</style>
